export const SOCIAL_LINKS = {
  EMAIL: 'mailto:wanv2002@gmail.com',
  LINKEDIN: 'https://www.linkedin.com/in/vincent-t-wan/',
  GITHUB: 'https://www.github.com/vincent-t-wan/',
};

export const NAV_LINKS = {
  ABOUT: '#about',
  EXPERIENCES: '#experiences',
  PROJECTS: '#projects',
  CONTACTS: '#contacts',
};

export const INTERSECTION_OBSERVER_OPTIONS = {
  root: null,
  rootMargin: '0px',
  threshold: 0.3,
};
